import { createFileRoute } from '@tanstack/react-router';
import Dashboard from '@pages/Dashboard';
import { z } from 'zod';

const helpRequestSearchSchema = z.object({
  district: z.string().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  helpCategories: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute('/dashboard')({
  validateSearch: helpRequestSearchSchema.parse,
  component: Dashboard,
});
